import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import { html } from 'lit';
import { StudentTags } from '../Student.js';

@Entity()
export class UserTagAspect extends AbstractAspect {
  static override _class = 'UserTagAspect';

  constructor(doc: PartialEntityData<UserTagAspect>) {
    const newDoc = {
      fieldName: 'tags',
      ...doc,
    };
    super(newDoc);
  }

  @Field(() => [String]) value: Maybe<StudentTags[]>;

  override getMongoFilter(): object | null {
    if (!this.value?.length || !this.fieldName) return null;

    return {
      [this.fieldName]: {
        $all: this.value,
      },
    };
  }
}

export const UserTagAspectSchema: AspectConfig<UserTagAspect> = {
  aspectConstructor: UserTagAspect,
  renderEditor: ({ aspectValue }) => html`
    <cr-dropdown-selection
      placeholder="Tags"
      placeholder-mode="hide"
      .selectables=${Object.values(StudentTags)}
      @value-picked=${(e: ValueEvent<Maybe<StudentTags>>) => {
        aspectValue.value = e.detail.value ? [e.detail.value] : null;
      }}
      .valueID=${aspectValue.value?.[0]}
    ></cr-dropdown-selection>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.value ? html` ${aspectValue.value} ` : null),
};
